import { useCallback, useEffect, useState } from "react";
import {
    Alert,
    Button,
    Col,
    Container,
    OverlayTrigger,
    Row,
    Tooltip,
} from "react-bootstrap";
import api from "../../../../service/api";
import { useParams } from "react-router-dom";
import ViewBatchStudentTpmrList from "./ViewBatchStudentsTpmrList";
import { tableColumn } from "./data";
import download from "downloadjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import { SnackbarAlert } from "../../../../components/SnackbarAlert";
import TpmrBatchDetails from "./BatchDetails";

const ViewBatchStudentsTpmr = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [classStudents, setClassStudents] = useState([]);
    const [batch, setBatch] = useState({});
    const [error, setError] = useState("");
    const [notif, setNotif] = useState({
        notifMsg: "",
        open: false,
        severity: "success",
    });

    const getData = useCallback(async () => {
        setLoading(true);
        try {
            const [batchRes, studentRes] = await Promise.all([
                api.get(`tms/batches/${id}`, {}),
                api.get(`tms/batches/${id}/batch-students`),
            ]);

            setBatch(batchRes.data);
            setClassStudents(studentRes.data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data");
            setError(
                "Error fetching data. Try again later or contact support."
            );
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        getData();
    }, [getData]);

    const exportBatchTpmr = async () => {
        try {
            setError("")
            const fileName = `${batch?.name}-${batch?.test_date}`;
            const response = await api.getexcel(
                `tms/student-tpmr/export-batch/${id}`
            );

            if (response.type === "application/json") {
                const text = await response.text();
                const jsonData = JSON.parse(text);

                if (jsonData.status === "ok" && jsonData.message) {
                    setError(jsonData.message || "No data to be exported")
                    return;
                }

                if (jsonData.error) {
                    setError(
                        jsonData.error || "An error occurred during export"
                    );
                    return;
                }
            }

            download(response, fileName, "application/xlsx");
            setNotif({
                notifMsg: "TPMR exported successfully!",
                open: true,
                severity: "success",
            });
        } catch (error) {
            setNotif({
                notifMsg: "TPMR export failed!",
                open: true,
                severity: "danger",
            });
        }
    };


    const batchDetailsProps = {
        batchId: batch?.id,
        name: batch?.name,
        courseName: batch?.course?.name,
        type: batch?.type,
        date: batch?.test_date,
        testVenue: batch?.test_venue,
        trainingVenue: batch?.training_venue,
        status: batch?.status,
        trainingDates: batch?.training_dates,
        adhocTrainingDates: batch?.adhoc_training_dates,
        course: batch?.course
    };

    return (
        <>
            <Container fluid className="p-0">
                <Row>
                    <Col md={5}>
                        <h1 className="h3 mb-3">Class - Students</h1>
                    </Col>
                </Row>
                {error && (
                    <Alert className="my-3" variant="danger">
                        <div className="alert-message">{error}</div>
                    </Alert>
                )}
                {loading && <div>Loading...</div>}
                {!loading && classStudents.length > 0 && (
                    <Row>
                        <Col md="4" xl="3">
                            <TpmrBatchDetails {...batchDetailsProps} />
                        </Col>
                        <Col md="8" xl="9">
                            <Row className="align-items-center mb-3 px-4">
                                <Col md="6">
                                    <h5 className="mb-0">Class Students</h5>
                                </Col>
                                <Col md="6" className="text-end">
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="tooltip-export">
                                                Export TPMR
                                            </Tooltip>
                                        }
                                    >
                                        <Button
                                            variant="info"
                                            onClick={() => exportBatchTpmr()}
                                        >
                                            <FontAwesomeIcon
                                                icon={faFileExport}
                                            />
                                            Export
                                        </Button>
                                    </OverlayTrigger>
                                </Col>
                            </Row>

                            <ViewBatchStudentTpmrList
                                data={classStudents}
                                columns={tableColumn}
                            />
                        </Col>
                    </Row>
                )}
                {!loading && classStudents.length === 0 && (
                    <Alert className="my-3" variant="warning">
                        <div className="alert-message">
                            No students under this batch/class
                        </div>
                    </Alert>
                )}
            </Container>
            <SnackbarAlert notif={notif} setNotif={setNotif} />
        </>
    );
};

export default ViewBatchStudentsTpmr;
